/**
 * Common translation keys used across the application
 * This file contains shared translation strings for UI elements
 */

import { userMaster } from "@/libs/routes";

// Sidebar translations
export const sidebar = {
  dashboard: "admin.sidebar_dashboard",
  master: "admin.sidebar_master",
  userMaster: "admin.sidebar_user_master",
  users: "admin.sidebar_users",
  settings: "admin.sidebar_settings",
  reportedUsers: "admin.reported_users_list_main_heading",
  userManagement: "admin.sidebar_user_management",
  dummyUsers: "admin.sidebar_dummy_users",
  normalUsers: "admin.sidebar_normal_users",
  freelancerUsers: "admin.sidebar_freelancer_users",
  reviews: "admin.sidebar_reviews",
  notifications: "admin.sidebar_notifications",
};

// Header profile menu translations
export const header_profile_menu = {
  profile: "admin.header_profile_menu_profile",
  settings: "admin.header_profile_menu_settings",
  logout: "admin.header_profile_menu_logout",
};

// Table translations
export const table = {
  noDataAvailable: "admin.table_no_data_available",
  loading: "admin.table_loading",
  actions: "admin.table_actions",
  edit: "admin.table_edit",
  delete: "admin.table_delete",
  view: "admin.table_view",
  status: "admin.table_status",
  active: "admin.table_active",
  inactive: "admin.table_inactive",
  pending: "admin.table_pending",
  approved: "admin.table_approved",
  rejected: "admin.table_rejected",
};

// File upload translations
export const file_upload = {
  chooseFile: "admin.file_upload_choose_file",
  dragDrop: "admin.file_upload_drag_drop",
  or: "admin.file_upload_or",
  browse: "admin.file_upload_browse",
  maxSize: "admin.file_upload_max_size",
  supportedFormats: "admin.file_upload_supported_formats",
  invalidFormat: "admin.file_upload_invalid_format",
  uploadButton: "admin.file_upload_upload_button",
  removeFile: "admin.file_upload_remove_file"
};

// Tab key translations
export const tab_key = {
  settings: {
    general_settings: "admin.tab_key_settings_general_settings",
    rewards_settings: "admin.tab_key_settings_rewards_settings",
    referral_settings: "admin.tab_key_settings_referral_settings",
    admin_rewards_settings: "admin.tab_key_settings_admin_rewards_settings"
  },
  dashboard: "admin.tab_key_dashboard",
  profile: "admin.tab_key_profile"
};

// Breadcrumb key translations
export const breadcrumb_key = {
  home: "admin.breadcrumb_key_home",
  dashboard: "admin.breadcrumb_key_dashboard",
  profile: "admin.breadcrumb_key_profile",
  editProfile: "admin.breadcrumb_key_edit_profile",
  users: "admin.breadcrumb_key_users",
  settings: "admin.breadcrumb_key_settings",
  masters: {
    translation: {
      list: "admin.breadcrumb_key_masters_translation_list",
      add: "admin.breadcrumb_key_masters_translation_add",
      edit: "admin.breadcrumb_key_masters_translation_edit",
    },
    cms: {
      list: "admin.breadcrumb_key_masters_cms_list",
      add: "admin.breadcrumb_key_masters_cms_add",
      edit: "admin.breadcrumb_key_masters_cms_edit",
    },
    emailTemplate: {
      list: "admin.breadcrumb_key_masters_email_template_list",
      add: "admin.breadcrumb_key_masters_email_template_add",
      edit: "admin.breadcrumb_key_masters_email_template_edit",
    },
    smsTemplate: {
      list: "admin.breadcrumb_key_masters_sms_template_list",
      add: "admin.breadcrumb_key_masters_sms_template_add",
      edit: "admin.breadcrumb_key_masters_sms_template_edit",
    },
    serviceCategory: {
      list: "admin.breadcrumb_key_masters_service_category_list",
      add: "admin.breadcrumb_key_masters_service_category_add",
      edit: "admin.breadcrumb_key_masters_service_category_edit",
    },
    subscriptionPlan: {
      list: "admin.breadcrumb_key_masters_subscription_plan_list",
      add: "admin.breadcrumb_key_masters_subscription_plan_add",
      edit: "admin.breadcrumb_key_masters_subscription_plan_edit",
    },
    subscribedUser: {
      list: "admin.breadcrumb_key_masters_subscribed_user_list",
      view: "admin.breadcrumb_key_masters_subscribed_user_view",
    },
    referralRecord: {
      list: "admin.breadcrumb_key_masters_referral_record_list",
      view: "admin.breadcrumb_key_masters_referral_record_view",
    },
    communityLeaderboard: {
      list: "admin.breadcrumb_key_masters_community_leaderboard_list",
    },
  },
  userMaster: {
    list: "admin.breadcrumb_key_user_master_list",
    view: "admin.breadcrumb_key_user_master_view",
    edit: "admin.breadcrumb_key_user_master_edit",
  },
  dummyUser: {
    list: "admin.breadcrumb_key_dummy_user_list",
    add: "admin.breadcrumb_key_dummy_user_add",
    edit: "admin.breadcrumb_key_dummy_user_edit",
    view: "admin.breadcrumb_key_dummy_user_view",
  },
  freelancerUser: {
    list: "admin.breadcrumb_key_freelancer_user_list",
    view: "admin.breadcrumb_key_freelancer_user_view",
  },
  reportedUsers: {
    list: "admin.reported_users_list_main_heading",
  },
  review: {
    list: "admin.review_list_heading",
    view: "admin.review_view_heading",
  },
  notification: {
    list: "admin.notification_list_heading",
  },
};

// Page not found translations
export const page_not_found = {
  title: "admin.page_not_found_title",
  description: "admin.page_not_found_description",
  backToHome: "admin.page_not_found_back_to_home",
};

// Session/Auto logout translations
export const session_auto_logout = {
  title: "admin.session_auto_logout_title",
  message: "admin.session_auto_logout_message",
  login: "admin.session_auto_logout_login",
}

// Notification translations
export const notification = {
  title: "admin.notification_title",
  markAllRead: "admin.notification_mark_all_read",
  noNotifications: "admin.notification_no_notifications",
}

// Common button labels
export const buttons = {
  submit: "admin.buttons_submit",
  cancel: "admin.buttons_cancel",
  save: "admin.buttons_save",
  delete: "admin.buttons_delete",
  edit: "admin.buttons_edit",
  view: "admin.buttons_view",
  back: "admin.buttons_back",
  next: "admin.buttons_next",
  previous: "admin.buttons_previous",
  search: "admin.buttons_search",
  filter: "admin.buttons_filter",
  reset: "admin.buttons_reset",
  confirm: "admin.buttons_confirm",
  close: "admin.buttons_close",
}

// Common form labels
export const form = {
  name: "admin.form_name",
  email: "admin.form_email",
  password: "admin.form_password",
  confirmPassword: "admin.form_confirm_password",
  phone: "admin.form_phone",
  address: "admin.form_address",
  city: "admin.form_city",
  country: "admin.form_country",
  zipCode: "admin.form_zip_code",
  description: "admin.form_description",
  status: "admin.form_status",
  createdAt: "admin.form_created_at",
  updatedAt: "admin.form_updated_at",
}

// Validation messages
export const validation = {
  required: "admin.validation_required",
  invalidEmail: "admin.validation_invalid_email",
  minLength: "admin.validation_min_length",
  maxLength: "admin.validation_max_length",
  passwordMismatch: "admin.validation_password_mismatch",
}

// Common action tooltip translations
export const action_tooltip = {
  edit: "admin.action_tooltip_edit",
  delete: "admin.action_tooltip_delete",
  view: "admin.action_tooltip_view",
};

// Success/Error messages
export const messages = {
  saveSuccess: "admin.messages_save_success",
  updateSuccess: "admin.messages_update_success",
  deleteSuccess: "admin.messages_delete_success",
  error: "admin.messages_error",
  confirmDelete: "admin.messages_confirm_delete",
  clearFilterBtnText: "admin.messages_clear_filter_btn_text",
  // Toast messages
  toast: {
    // Translation related messages
    translation: {
      deleted: "admin.messages_translation_deleted",
      deleteFailed: "admin.messages_translation_delete_failed",
      added: "admin.messages_translation_added",
      addFailed: "admin.messages_translation_add_failed",
      updated: "admin.messages_translation_updated",
      updateFailed: "admin.messages_translation_update_failed",
      synced: "admin.messages_translation_synced",
      syncFailed: "admin.messages_translation_sync_failed",
      imported: "admin.messages_translation_imported",
      importFailed: "admin.messages_translation_import_failed",
      exported: "admin.messages_translation_exported",
      exportFailed: "admin.messages_translation_export_failed",
      fetchFailed: "admin.messages_translation_fetch_failed",
      languagesFetchFailed: "admin.messages_translation_languages_fetch_failed",
      dataFetchFailed: "admin.messages_translation_data_fetch_failed"
    },
    // CMS related messages
    cms: {
      statusUpdated: "admin.cms_status_updated_successfully",
      statusUpdateFailed: "admin.cms_status_update_failed",
      deleted: "admin.cms_deleted_successfully",
      added: "admin.cms_added_successfully",
      addFailed: "admin.cms_add_failed",
      updated: "admin.cms_updated_successfully",
      updateFailed: "admin.cms_update_failed",
      dataFetchFailed: "admin.cms_data_fetch_failed",
      fetchFailed: "admin.cms_fetch_failed",
    },
    // Email Template related messages
    emailTemplate: {
      deleted: "admin.email_template_deleted_successfully",
      deleteFailed: "admin.email_template_delete_failed",
      added: "admin.email_template_added_successfully",
      addFailed: "admin.email_template_add_failed",
      updated: "admin.email_template_updated_successfully",
      updateFailed: "admin.email_template_update_failed",
      fetchFailed: "admin.messages_email_template_fetch_failed",
      dataFetchFailed: "admin.messages_email_template_data_fetch_failed",
    },
    // SMS Template related messages
    smsTemplate: {
      deleted: "admin.sms_template_deleted_successfully",
      deleteFailed: "admin.sms_template_delete_failed",
      added: "admin.sms_template_added_successfully",
      addFailed: "admin.sms_template_add_failed",
      updated: "admin.sms_template_updated_successfully",
      updateFailed: "admin.sms_template_update_failed",
      fetchFailed: "admin.messages_sms_template_fetch_failed",
      dataFetchFailed: "admin.messages_sms_template_data_fetch_failed",
    },
    // Service Category related messages
    serviceCategory: {
      deleted: "admin.service_category_deleted_successfully",
      deleteFailed: "admin.service_category_delete_failed",
      added: "admin.service_category_added_successfully",
      addFailed: "admin.service_category_add_failed",
      updated: "admin.service_category_updated_successfully",
      updateFailed: "admin.service_category_update_failed",
      statusUpdated: "admin.service_category_status_updated_successfully",
      statusUpdateFailed: "admin.service_category_status_update_failed",
      fetchFailed: "admin.messages_service_category_fetch_failed",
      dataFetchFailed: "admin.messages_service_category_data_fetch_failed",
    },
    // Subscription Plan related messages
    subscriptionPlan: {
      deleted: "admin.subscription_plan_deleted_successfully",
      deleteFailed: "admin.subscription_plan_delete_failed",
      added: "admin.subscription_plan_added_successfully",
      addFailed: "admin.subscription_plan_add_failed",
      updated: "admin.subscription_plan_updated_successfully",
      updateFailed: "admin.subscription_plan_update_failed",
      statusUpdated: "admin.subscription_plan_status_updated_successfully",
      statusUpdateFailed: "admin.subscription_plan_status_update_failed",
      fetchFailed: "admin.messages_subscription_plan_fetch_failed",
      dataFetchFailed: "admin.messages_subscription_plan_data_fetch_failed",
    },
    // Dummy User related messages
    dummyUser: {
      deleted: "admin.dummy_user_deleted_successfully",
      deleteFailed: "admin.dummy_user_delete_failed",
      added: "admin.dummy_user_added_successfully",
      addFailed: "admin.dummy_user_add_failed",
      updated: "admin.dummy_user_updated_successfully",
      updateFailed: "admin.dummy_user_update_failed",
      statusUpdated: "admin.dummy_user_status_updated_successfully",
      statusUpdateFailed: "admin.dummy_user_status_update_failed",
      fetchFailed: "admin.messages_dummy_user_fetch_failed",
      dataFetchFailed: "admin.messages_dummy_user_data_fetch_failed",
    },
    // General success messages
    success: {
      created: "admin.messages_success_created",
      saved: "admin.messages_success_saved",
      updated: "admin.messages_success_updated",
      deleted: "admin.messages_success_deleted",
      uploaded: "admin.messages_success_uploaded",
      downloaded: "admin.messages_success_downloaded"
    },
    // General error messages
    error: {
      general: "admin.messages_error_general",
      network: "admin.messages_error_network",
      validation: "admin.messages_error_validation",
      unauthorized: "admin.messages_error_unauthorized",
      notFound: "admin.messages_error_not_found",
      server: "admin.messages_error_server"
    },
    // Loading messages
    loading: {
      saving: "admin.messages_loading_saving",
      deleting: "admin.messages_loading_deleting",
      updating: "admin.messages_loading_updating",
      loading: "admin.messages_loading_loading",
      processing: "admin.messages_loading_processing"
    }
  }
};
